import { initAuthConfig, getAmplifyBackend, isAuthConfigInitialized } from '@nestingale/auth'
import { resolveConfig, type BrandKey } from '@/config/configService'
import { getBrand } from '@/config/brandDetection'

/**
 * Initialize @nestingale/auth config from configService, then configure Amplify v6.
 *
 * The active brand is auto-detected from the URL via `getBrand()`.
 * Pass an explicit `brand` to override (e.g. when the brand is already known server-side).
 *
 * Safe to call multiple times; skips if already initialized.
 */
export const configureAmplify = (brand?: BrandKey) => {
  try {
    if (isAuthConfigInitialized()) return true

    const activeBrand = brand ?? getBrand()

    const amplify = resolveConfig('amplify', activeBrand)
    const google = resolveConfig('google', activeBrand)
    const apple = resolveConfig('apple', activeBrand)

    initAuthConfig({
      amplify,
      google,
      apple,
      apiBaseUrl: 'https://nestingale.com',
    })

    const backend = getAmplifyBackend()
    backend.configure()
    console.log(`configureAmplify: initiated via @nestingale/auth v6 (brand: ${activeBrand})`)
    return true
  } catch (error) {
    console.error('Error configuring Amplify:', error)
    return false
  }
}
